"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export default function GAReporter({ gaId }: { gaId: string }) {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (!gaId || typeof window === "undefined" || !window.gtag) return;
        const url = pathname + (searchParams?.toString() ? `?${searchParams}` : "");
        window.gtag("event", "page_view", {
            page_location: window.location.origin + url,
            page_path: url,
            page_title: document?.title,
        });
    }, [gaId, pathname, searchParams]);

    return null;
}